export default "__VITE_ASSET__DBs3NaLA__"